module.exports = __webpack_public_path__ + "static/img/叉车.1c8f8fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/叉车.jpg
// module id = wtzt
// module chunks = 1